export const columnsCompany = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '发布者',
    dataIndex: 'admin_name',
  },
  {
    title: '区域',
    dataIndex: 'admin_area',
  },
  {
    title: '任务名称',
    dataIndex: 'task_name',
  },
  {
    title: '任务类型',
    dataIndex: 'task_type_name',
  },
  {
    title: '任务周期',
    dataIndex: 'time',
  },
  {
    title: '任务发起时间',
    dataIndex: 'create_time',
  },
  {
    title: '反馈数',
    dataIndex: 'feedback_count',
    scopedSlots: { customRender: 'feedback_count' },
  },
  {
    title: '推广人',
    dataIndex: 'promoter',
    scopedSlots: { customRender: 'promoter' },
  },
  {
    title: '推广资料',
    dataIndex: 'task',
    scopedSlots: { customRender: 'task' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const columnsService = [
  {
    title: '编号',
    dataIndex: 'id',
  },
   {
    title: '任务名称',
    dataIndex: 'task_name',
  },
  // {
  //   title: '合作机构',
  //   dataIndex: 'company_name',
  // },
  // {
  //   title: '发布者',
  //   dataIndex: 'admin_name',
  // },
  // {
  //   title: '发布者大区',
  //   dataIndex: 'admin_area',
  // },
 
  {
    title: '任务类型',
    dataIndex: 'task_type_name',
  },
  {
    title: '任务周期',
    dataIndex: 'time',
  },
  {
    title: '任务发起时间',
    dataIndex: 'create_time',
  },
  {
    title: '反馈数',
    dataIndex: 'feedback_count',
    scopedSlots: { customRender: 'feedback_count' },
  },
  {
    title: '推广人',
    dataIndex: 'promoter',
    scopedSlots: { customRender: 'promoter' },
  },
  {
    title: '推广资料',
    dataIndex: 'task',
    scopedSlots: { customRender: 'task' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];


export const formDataCompany = [
  {
    name: 'task_type',
    lable: '任务类型',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'datas',
    lable: '选择素材',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },

  {
    name: 'promoters',
    lable: '选择学术推广员',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'time',
    lable: '任务期限',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'require_desc',
    lable: '任务要求',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'task_name',
    lable: '任务名称',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },

];
export const formDataService = [
  {
    name: 'task_type',
    lable: '任务类型',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },

  {
    name: 'company_id',
    lable: '选择药企',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'admin_id',
    lable: '选择发布者',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'promoters',
    lable: '选择学术推广员',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'datas',
    lable: '选择素材',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'time',
    lable: '任务期限',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'require_desc',
    lable: '任务要求',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },
  {
    name: 'task_name',
    lable: '任务名称',
    lableCol: 6,
    wrapperCol: 12,
    offset: 0,
    span: 24,
  },

];
